import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SimplePanel from '@/shared/components/SimplePanel';
import messages from '@/modules/tasks/taskboard/taskboardMessages';
import { useIntl } from 'react-intl';
import { CanCreate } from '@/shared/components/security';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import taskMessages from '@/modules/tasks/taskMessages';
import { FilterUserSearch } from '@/shared/components/input/filterInputs/FilterUserSearch';
import { FilterStatusSelect } from '@/shared/components/input/filterInputs/FilterStatusSelect';
import { FilterTaskTemplateMultiSelect } from '@/shared/components/input/filterInputs/FilterTaskTemplateMultiSelect';
import { FilterDelayedDateRangePicker } from '@/shared/components/input/filterInputs/FilterDelayedDateRangePicker';
import { FilterSubtaskTemplateSelect } from '@/shared/components/input/filterInputs/FilterSubtaskTemplateSelect';
import { FilterRelationSearch } from '@/shared/components/input/filterInputs/FilterRelationSearch';
import { FilterEnumMultiSelect } from '@/shared/components/input/filterInputs/FilterEnumMultiSelect';
import { FilterLegalFormMultiSelect } from '@/shared/components/input/filterInputs/FilterLegalFormMultiSelect';
import { FilterCompanyMultiSelect } from '@/shared/components/input/filterInputs/FilterCompanyMultiSelect';
import { FilterLegalEntityMultiSelect } from '@/shared/components/input/filterInputs/FilterLegalEntityMultiSelect';
import { useHasMultipleLegalEntities } from '@/shared/components/security/HasMultipleLegalEntities';
import { FilterEndFiscalYearMultiSelect } from '@/shared/components/input/filterInputs/FilterEndFiscalYearMultiSelect';
import { FilterPlannedTasksTagsMultiSelect } from '@/shared/components/input/filterInputs/FilterPlannedTasksTagsMultiSelect';
import { FilterResourceTagsMultiSelect } from '@/shared/components/input/filterInputs/FilterResourceTagsMultiSelect';
import { FilterRelationTypeButtons } from '@/shared/components/input/filterInputs/FilterRelationTypeButtons';
import { FilterCrmTypeButtons } from '@/shared/components/input/filterInputs/FilterCrmTypeButtons';
import { FilterMyTeamsMultiSelect } from '@/shared/components/input/filterInputs/FilterMyTeamsMultiSelect';
import { FilterTaskPeriodicitySelect } from '@/shared/components/input/filterInputs/FilterTaskPeriodicitySelect';
import { FilterToggleSelect } from '@/shared/components/input/filterInputs/FilterToggleSelect';
import { FilterAssignmentTemplateSelector } from '@/shared/components/input/filterInputs/FilterAssignmentTemplateSelector';
import { FilterRelationGroupMultiSelect } from '@/shared/components/input/filterInputs/FilterRelationGroupMultiSelect';
import { FilterReferenceYear } from '@/shared/components/input/filterInputs/FilterReferenceYear';
import { FilterWrapper } from '@/shared/components/FilterWrapper';
import authService from '@/shared/services/AuthService';
import { TaskBoardFilterKPIs } from './TaskboardFilterKPIs';
import { TaskBoardFilterType, } from '../../constants';
import employeeProfileMessages from '@/shared/messages/employeeProfileMessages';
import { FilterYesNoSelect } from '@/shared/components/input/filterInputs/FilterYesNoSelect';
export const TaskBoardFilters = ({ activeFilters, setFilter }) => {
    const { formatMessage } = useIntl();
    const { setShowModalInfo } = useModalContext();
    const hasMultipleLegalEntities = useHasMultipleLegalEntities();
    const onCreateNewTask = () => {
        setShowModalInfo({
            modalType: ModalType.OneTimeTask,
            relationId: activeFilters.relationId,
        });
    };
    return (_jsxs(SimplePanel, Object.assign({ article: "5434833712530", title: formatMessage(messages.TaskBoard), buttons: _jsx(CanCreate, Object.assign({ on: "PlannedTask" }, { children: _jsxs("button", Object.assign({ onClick: onCreateNewTask, id: "taskboard-new-task-button", title: formatMessage(taskMessages.NewTask), className: "btn btn-inverse", type: "button" }, { children: [_jsx("i", { className: "fa fa-plus" }), _jsx("span", Object.assign({ className: "margin5L" }, { children: formatMessage(messages.Add) }))] })) })) }, { children: [_jsx(TaskBoardFilterKPIs, { filters: activeFilters, setActiveKPI: kpi => setFilter({ kpi }) }), _jsx("div", Object.assign({ className: "info-block container-fluid" }, { children: _jsx(FilterWrapper, Object.assign({ filterObject: activeFilters, setFilter: setFilter, resetFilters: undefined, hasActiveFilters: undefined, screen: "TaskBoard", invisibleFilters: ['plannedTaskId', 'invoiceStreamId', 'kpi', 'filterBehaviours'] }, { children: [
                        FilterRelationSearch({
                            item: TaskBoardFilterType.relationId,
                            itemName: TaskBoardFilterType.relationName,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.userId,
                            label: formatMessage(messages.TasksAssignedTo),
                            isAlwaysVisible: true,
                            withUnassigned: true,
                            withNotAssignedToMe: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterTaskTemplateMultiSelect({
                            item: TaskBoardFilterType.taskTemplates,
                            clearItems: [TaskBoardFilterType.subtaskId, TaskBoardFilterType.periodicityId],
                            label: formatMessage(messages.SelectTask),
                            isAlwaysVisible: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterStatusSelect({
                            item: TaskBoardFilterType.status,
                            label: formatMessage(messages.Status),
                            isAlwaysVisible: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterDelayedDateRangePicker({
                            startDateItem: TaskBoardFilterType.deadlineFrom,
                            endDateItem: TaskBoardFilterType.deadlineUntil,
                            startDateId: 'TaskBoardStartDateFilter',
                            endDateId: 'TaskBoardEndDateFilter',
                            startDatePlaceholder: formatMessage(messages.DeadlineFromPlaceholder),
                            endDatePlaceholder: formatMessage(messages.DeadlineUntilPlaceholder),
                            iconClassName: 'fa fa-calendar',
                            iconTitle: formatMessage(taskMessages.Deadline),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterDelayedDateRangePicker({
                            startDateItem: TaskBoardFilterType.executionDateFrom,
                            endDateItem: TaskBoardFilterType.executionDateUntil,
                            startDateId: 'TaskBoardExecutionStartDateFilter',
                            endDateId: 'TaskBoardExecutionEndDateFilter',
                            startDatePlaceholder: formatMessage(messages.ExecutionDateFrom),
                            endDatePlaceholder: formatMessage(messages.ExecutionDateUntil),
                            iconClassName: 'fa fa-calendar-check-o',
                            iconTitle: formatMessage(taskMessages.ExecutionDate),
                            setFilter,
                            activeFilters,
                            enabled: authService.hasFeature('CapacityPlanning'),
                        }),
                        FilterSubtaskTemplateSelect({
                            item: TaskBoardFilterType.subtaskId,
                            label: formatMessage(messages.SelectASubtask),
                            isAlwaysVisible: true,
                            taskTemplatesItem: TaskBoardFilterType.taskTemplates,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterStatusSelect({
                            item: TaskBoardFilterType.subtaskStatus,
                            label: formatMessage(messages.SubtaskStatus),
                            isAlwaysVisible: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterTaskPeriodicitySelect({
                            item: TaskBoardFilterType.periodicityId,
                            label: formatMessage(messages.FilterPeriodicity),
                            isAlwaysVisible: true,
                            taskTemplatesItem: TaskBoardFilterType.taskTemplates,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.vatPeriodicity,
                            type: 'vatPeriodicity',
                            label: formatMessage(messages.VatPeriodicity),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.financialStatementScheme,
                            type: 'financialStatementScheme',
                            label: formatMessage(messages.FinancialStatementScheme),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.socialSecurityFund,
                            type: 'socialSecurityFund',
                            label: formatMessage(messages.SocialSecurityFund),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.socialSecretariat,
                            type: 'socialSecretariat',
                            label: formatMessage(messages.SocialSecretariat),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.accountingSoftware,
                            type: 'accountingSoftware',
                            customItems: [{ id: -1, label: formatMessage(messages.EmptyAccountingSoftware) }],
                            label: formatMessage(messages.AccountingSoftware),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.receiveInvoiceSoftware,
                            type: 'receiveInvoiceSoftware',
                            customItems: [{ id: -1, label: formatMessage(messages.EmptyReceiveInvoiceSoftware) }],
                            label: formatMessage(messages.ReceiveInvoiceSoftware),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.otherSoftware,
                            type: 'otherSoftware',
                            label: formatMessage(messages.OtherSoftware),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.sendInvoiceSoftware,
                            type: 'sendInvoiceSoftware',
                            label: formatMessage(messages.SendInvoiceSoftware),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterCompanyMultiSelect({
                            item: TaskBoardFilterType.ownCompanies,
                            label: formatMessage(messages.OwnCompanies),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterLegalEntityMultiSelect({
                            item: TaskBoardFilterType.legalEntities,
                            label: formatMessage(messages.LegalEntity),
                            setFilter,
                            activeFilters,
                            enabled: hasMultipleLegalEntities,
                        }),
                        FilterEndFiscalYearMultiSelect({
                            item: TaskBoardFilterType.endFiscalYears,
                            label: formatMessage(messages.EndFiscalYear),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.createdBy,
                            label: formatMessage(messages.CreatedBy),
                            withCurrentUser: false,
                            withByPlanning: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.assistant,
                            label: formatMessage(employeeProfileMessages.Assistant),
                            withUnassigned: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.assistantBackup,
                            label: formatMessage(employeeProfileMessages.AssistantBackup),
                            withUnassigned: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.seniorUser,
                            label: formatMessage(employeeProfileMessages.SeniorUser),
                            withUnassigned: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.billingUser,
                            label: formatMessage(employeeProfileMessages.BillingUser),
                            withUnassigned: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterAssignmentTemplateSelector({
                            item: TaskBoardFilterType.assignmentTemplateId,
                            label: formatMessage(messages.AssignmentTemplate),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterLegalFormMultiSelect({
                            item: TaskBoardFilterType.legalForms,
                            label: formatMessage(messages.LegalForms),
                            setFilter,
                            activeFilters,
                            showWithoutOption: true,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.relationUserId,
                            label: formatMessage(messages.RelationsAssignedTo),
                            withUnassigned: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterResourceTagsMultiSelect({
                            item: TaskBoardFilterType.relationTags,
                            label: formatMessage(messages.WithRelationLabels),
                            setFilter,
                            activeFilters,
                            withFilterBehaviour: true,
                            enabled: true,
                        }),
                        FilterResourceTagsMultiSelect({
                            item: TaskBoardFilterType.withoutRelationTags,
                            label: formatMessage(messages.WithoutRelationLabels),
                            setFilter,
                            activeFilters,
                            withFilterBehaviour: false,
                            enabled: true,
                        }),
                        FilterRelationTypeButtons({
                            item: TaskBoardFilterType.relationTypes,
                            label: formatMessage(messages.RelationType),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterCrmTypeButtons({
                            item: TaskBoardFilterType.crmTypes,
                            label: formatMessage(messages.CrmType),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterMyTeamsMultiSelect({
                            item: TaskBoardFilterType.teams,
                            label: formatMessage(messages.RelationTeams),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.associate,
                            label: formatMessage(employeeProfileMessages.Associate),
                            withUnassigned: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterUserSearch({
                            item: TaskBoardFilterType.responsible,
                            label: formatMessage(employeeProfileMessages.Responsible),
                            withUnassigned: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterPlannedTasksTagsMultiSelect({
                            item: TaskBoardFilterType.withoutTags,
                            label: formatMessage(messages.WithoutTaskLabels),
                            setFilter,
                            activeFilters,
                            withFilterBehaviour: false,
                            enabled: true,
                        }),
                        FilterPlannedTasksTagsMultiSelect({
                            item: TaskBoardFilterType.withTags,
                            label: formatMessage(messages.WithTaskLabels),
                            setFilter,
                            activeFilters,
                            withFilterBehaviour: true,
                            enabled: true,
                        }),
                        FilterToggleSelect({
                            item: TaskBoardFilterType.onlySubtasksForAssignedUser,
                            label: formatMessage(messages.ShowOnlySubtaskAssignedToSelectedUser),
                            isAlwaysVisible: true,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterToggleSelect({
                            item: TaskBoardFilterType.userIsNextAssignedUser,
                            label: formatMessage(messages.ShowTasksWhereSelectedUserIsNextInLine),
                            tooltip: formatMessage(messages.ShowTasksWhereSelectedUserIsNextInLineTooltip),
                            isAlwaysVisible: true,
                            enabled: true,
                            setFilter: updatedFilters => {
                                // when enabling this filter and no userId is filtered, set the userId to the current user
                                if (updatedFilters.userIsNextAssignedUser && !activeFilters.userId) {
                                    setFilter(Object.assign(Object.assign({}, updatedFilters), { userId: authService.getUserId() }));
                                }
                                else {
                                    setFilter(updatedFilters);
                                }
                            },
                            activeFilters,
                        }),
                        FilterToggleSelect({
                            item: TaskBoardFilterType.includeDoneTasksInThePast,
                            label: formatMessage(messages.IncludeDoneTasksInThePast),
                            isAlwaysVisible: false,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterToggleSelect({
                            item: TaskBoardFilterType.sortByExecutionDate,
                            label: formatMessage(messages.SortByExecutionDate),
                            isAlwaysVisible: true,
                            setFilter,
                            activeFilters,
                            enabled: authService.hasFeature('CapacityPlanning'),
                        }),
                        FilterRelationGroupMultiSelect({
                            item: TaskBoardFilterType.relationGroups,
                            label: formatMessage(messages.RelationGroups),
                            isAlwaysVisible: false,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterReferenceYear({
                            item: TaskBoardFilterType.year,
                            label: formatMessage(messages.ReferenceYear),
                            isAlwaysVisible: false,
                            setFilter,
                            activeFilters,
                            enabled: authService.hasFeature('referenceYear'),
                        }),
                        FilterYesNoSelect({
                            item: TaskBoardFilterType.mixedTaxPayer,
                            label: formatMessage(messages.MixedTaxPayer),
                            isAlwaysVisible: false,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.mixedTaxPayerVatDeductionMethod,
                            type: 'MixedTaxPayerVatDeductionMethod',
                            label: formatMessage(messages.MixedTaxPayerVatDeductionMethod),
                            customItems: [
                                { id: -1, label: formatMessage(messages.EmptyMixedTaxPayerVatDeductionMethod) },
                            ],
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterYesNoSelect({
                            item: TaskBoardFilterType.selfBooker,
                            label: formatMessage(messages.Selfbooker),
                            isAlwaysVisible: false,
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.relationHandlingLevels,
                            type: 'relationHandlingLevel',
                            label: formatMessage(messages.RelationHandlingLevel),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.capitalGainsTax,
                            type: 'capitalGainsTax',
                            label: formatMessage(messages.CapitalGainsTax),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                        FilterEnumMultiSelect({
                            item: TaskBoardFilterType.statute,
                            type: 'statute',
                            label: formatMessage(messages.Statute),
                            setFilter,
                            activeFilters,
                            enabled: true,
                        }),
                    ] })) }))] })));
};
